export default __webpack_public_path__ + "static/GT-America-Mono-Regular-79de0e85f95476ff2573b9fbd2421892.woff";